import { Category, Store, Tag } from "@mui/icons-material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import SellIcon from "@mui/icons-material/Sell";
import NotesIcon from '@mui/icons-material/Notes';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SIDEBAR_ITEMS = [
  {
    id: "home",
    label: "Dashboard",
    url: "/dashboard",
    icon: <DashboardIcon />,
  },
  { label: "Users", url: "/users", icon: <PeopleIcon /> },
  {
    id: "products",
    label: "Products",
    url: "/products",
    icon: <SellIcon />,
  },
  {
    id: "autosuggest",
    label: "Auto suggestion",
    url: "/autosuggest",
    icon: <Store />,
  },
  {
    id: "categories",
    label: "Categories",
    url: "/categories",
    icon: <Category />,
  },
  {
    id: "affiliate-tags",
    label: "Affiliate Tags",
    url: "/affiliate-tags",
    icon: <Tag />,
  },
  {
    id: "aisurevey",
    label: "AI Survey",
    url: "/aisurvey",
    icon: <NotesIcon />,
  },
];

export const MainListItems = ({ open }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (url) => {
    return location.pathname === url;
  };

  const handleItemClick = (url) => {
    navigate(url);
  };

  return (
    <>
      {SIDEBAR_ITEMS.map((item, index) => (
        <ListItemButton
          key={index}
          onClick={() => handleItemClick(item.url)}
          selected={isActive(item.url)}
        >
          {open ? (
            <ListItemIcon>{item.icon}</ListItemIcon>
          ) : (
            <Tooltip title={item.label} placement="right" arrow>
              <ListItemIcon>{item.icon}</ListItemIcon>
            </Tooltip>
          )}
          <ListItemText primary={item.label} />
        </ListItemButton>
      ))}
    </>
  );
};
